/**
 * Αποκωδικοποιεί ένα Base64 string πίσω σε απλό κείμενο.
 * @param {string} base64 - Το κωδικοποιημένο email
 * @returns {string} - Το κανονικό email
 */
export const decodeEmail = (base64) => {
  if (!base64) return '';
  return atob(base64);
};

/**
 * Βοηθητική συνάρτηση (προαιρετική): Αν θέλεις στο μέλλον να αλλάξεις email,
 * τρέξε αυτή τη συνάρτηση για να πάρεις το νέο Base64 string.
 * π.χ. encodeToBase64('test@example.com') -> 'dGVzdEBleGFtcGxlLmNvbQ=='
 */
export const encodeToBase64 = (text) => {
  return btoa(text);
};
